function primaryNavigation() {
    const nav = document.querySelector('[data-primary-navigation]');
    if (!nav) return;

    const mobileQuery = window.matchMedia('(max-width: 767px)');
    const rawItems = Array.from(nav.querySelectorAll('[data-navigation-item]')).map(function (item) {
        return {
            href: item.href,
            label: item.textContent.trim()
        };
    });
    const reserved = [
        {key: 'home', label: 'Home'},
        {key: 'latest', label: 'Latest'}
    ];
    let activeMore;
    let resizeTimer;

    function normalizedPath(pathname) {
        return pathname.replace(/\/+$/, '') || '/';
    }

    function reservedKey(item) {
        const url = new URL(item.href, window.location.origin);

        if (normalizedPath(url.pathname) === '/') return 'home';
        if (normalizedPath(url.pathname) === '/latest') return 'latest';

        return null;
    }

    function navigationEntries() {
        const entries = [];
        const found = new Set();
        let group;

        rawItems.forEach(function (item) {
            const parentMatch = item.label.match(/^\[-\]\s*(.+)$/);
            const childMatch = item.label.match(/^\[--\]\s*(.+)$/);

            if (parentMatch) {
                group = {type: 'group', label: parentMatch[1], items: []};
                entries.push(group);
                return;
            }

            if (childMatch && group) {
                group.items.push({href: item.href, label: childMatch[1]});
                return;
            }

            group = null;
            const key = reservedKey(item);

            if (key && !found.has(key)) {
                found.add(key);
                entries.push({type: key});
                return;
            }

            entries.push({type: 'link', href: item.href, label: childMatch ? childMatch[1] : item.label});
        });

        reserved.slice().reverse().forEach(function (item) {
            if (!found.has(item.key)) {
                entries.unshift({type: item.key});
            }
        });

        return entries;
    }

    function makeEntry(entry) {
        if (entry.type === 'group') {
            const menu = document.createElement('details');
            const summary = document.createElement('summary');
            const dropdown = document.createElement('div');

            menu.className = 'gh-primary-navigation-group';
            summary.textContent = entry.label;
            dropdown.className = 'gh-primary-navigation-dropdown';

            entry.items.forEach(function (item) {
                const link = document.createElement('a');
                link.href = item.href;
                link.textContent = item.label;
                dropdown.appendChild(link);
            });

            menu.append(summary, dropdown);
            return menu;
        }

        const link = document.createElement('a');
        link.className = 'gh-primary-navigation-item';

        if (entry.type === 'home') {
            link.href = '/';
            link.textContent = 'Home';
        } else if (entry.type === 'latest') {
            link.href = '/latest/';
            link.textContent = 'Latest';
        } else {
            link.href = entry.href;
            link.textContent = entry.label;
        }

        return link;
    }

    function closeMore(more) {
        more.classList.remove('is-open');
        more.querySelector('.gh-primary-navigation-more-toggle').setAttribute('aria-expanded', 'false');
        more.querySelectorAll('.gh-primary-navigation-group[open]').forEach(function (menu) {
            menu.open = false;
        });
        activeMore = null;
    }

    function makeMore(entries) {
        const more = document.createElement('div');
        const toggle = document.createElement('button');
        const dropdown = document.createElement('div');

        more.className = 'gh-primary-navigation-more';
        toggle.className = 'gh-primary-navigation-more-toggle gh-icon-button';
        toggle.type = 'button';
        toggle.setAttribute('aria-label', 'More navigation');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = '•••';

        dropdown.className = 'gh-primary-navigation-overflow';
        dropdown.id = 'gh-primary-navigation-overflow';
        toggle.setAttribute('aria-controls', dropdown.id);
        entries.forEach(function (entry) {
            dropdown.appendChild(makeEntry(entry));
        });

        dropdown.addEventListener('click', function (event) {
            if (!event.target.closest('a')) return;

            closeMore(more);
        });

        more.append(toggle, dropdown);
        toggle.addEventListener('click', function (event) {
            event.stopPropagation();
            if (more.classList.contains('is-open')) {
                closeMore(more);
                return;
            }

            nav.querySelectorAll('.gh-primary-navigation-group[open]').forEach(function (menu) {
                menu.open = false;
            });
            more.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
            activeMore = more;
        });

        return more;
    }

    function render(entries, visibleCount) {
        const visible = entries.slice(0, visibleCount);
        const overflow = entries.slice(visibleCount);
        const fragment = document.createDocumentFragment();

        visible.forEach(function (entry) {
            fragment.appendChild(makeEntry(entry));
        });

        if (overflow.length) {
            fragment.appendChild(makeMore(overflow));
        }

        nav.replaceChildren(fragment);
        activeMore = null;
        nav.querySelectorAll('.gh-primary-navigation-group').forEach(function (menu) {
            menu.addEventListener('toggle', function () {
                if (!menu.open) return;

                nav.querySelectorAll('.gh-primary-navigation-group[open]').forEach(function (otherMenu) {
                    if (otherMenu !== menu) otherMenu.open = false;
                });
            });
        });
        navigationGroups();
    }

    function layout() {
        const entries = navigationEntries();

        if (mobileQuery.matches) {
            render(entries, entries.length);
            return;
        }

        let visibleCount = Math.min(entries.length, 6);
        render(entries, visibleCount);

        const availableWidth = nav.parentElement.clientWidth;
        while (visibleCount > 1 && nav.scrollWidth > availableWidth) {
            visibleCount -= 1;
            render(entries, visibleCount);
        }
    }

    document.addEventListener('click', function (event) {
        if (event.target.closest('.gh-primary-navigation-more-toggle')) return;

        if (activeMore && !activeMore.contains(event.target)) {
            closeMore(activeMore);
        }
    });

    window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(layout, 80);
    });

    window.addEventListener('load', layout, {once: true});
    layout();
}
